import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "es-patient-main" }
const _hoisted_2 = { class: "main-zone" }
const _hoisted_3 = { class: "mtop-04" }
const _hoisted_4 = {
  key: 0,
  class: "r-bar bg-primary"
}
const _hoisted_5 = {
  key: 1,
  class: "colCenter ptop-10 es-right-bar"
}
const _hoisted_6 = { class: "h4" }

import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import loadingSpinner from '@/views/loadingSpinner.vue'
import lBarUpperMenu from '@/views/patientMain/leftBar/lBarUpperMenu.vue';
import lBarCs from '@/views/patientMain/leftBar/lBarCs.vue';
import rBarMonitored from '@/views/patientMain/rightBar/rBarMonitored.vue';
import rBarTtt from '@/views/patientMain/rightBar/rBarTtt.vue';
import rBarHistory from '@/views/patientMain/rightBar/rBarHistory.vue';
import rBarEcosystem from '@/views/patientMain/rightBar/rBarEcosystem.vue';
import dashbExpr from '@/views/patientMain/dashbExpr/dashbExpr.vue';
import dashbHistory from '@/views/patientMain/dashbHistory/dashbHistory.vue';
import dashbEcosystem from '@/views/patientMain/dashbEcosystem/dashbEcosystem.vue';
import dashbMedicAll from '@/views/patientMain/dashbMedic/dashbMedicAll.vue';
import dashbVacc from '@/views/patientMain/dashbVaccins/dashbVacc.vue';
import dashbResultDocument from '@/views/patientMain/dashbExpr/dashbResultDocument.vue';
import dashbOphtalmo from '@/views/patientMain/dashbVaccins/dashbOphtalmo.vue';
import { usePermissionsStore } from '@/stores/permissionsStore';
import router from '@/router';
import { useRoute } from 'vue-router';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useUiStore } from '@/stores/ui';
import { InstituteApi, PersonLightResponse, FolderPatientApi, PatientSummaryResponse  } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ApiError } from '@/models/share.model';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { useAppUserStore } from '@/stores/appUser';
import { getSingleElement } from '@/utils/array-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'esPatientMain',
  emits: ['modal-close'],
  setup(__props, { emit: __emit }) {

const uiStore = useUiStore();
const currentEntryStore = useCurrentEntryStore();
const appUserStore = useAppUserStore();
const permissionsStore = usePermissionsStore();
const folderPatientApi = new FolderPatientApi(medServerApiConfig);

const instituteApi = new InstituteApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();

const emits = __emit;
const showRightBar = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const reloadPatientData = ref<boolean>(false);
const reloadTreatmentData = ref<boolean>(false);

const route = useRoute();

const currentPerson = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr
});

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {
    return "";
  }
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return currentIwr.instituteWithRoleId;
});

const dashb = computed(() => {
  if (!uiStore.dashBoardItem && !uiStore.dashBoardItemType) return null;
  const itemType = uiStore.dashBoardItemType;
  if (itemType.substring(0, 7) === "History") return dashbHistory;
  const dashbList = {
    "Ecosystem": dashbEcosystem,
    "Medic": dashbMedicAll,
    "Vacc": dashbVacc,
    "Ophtalmo": dashbOphtalmo
  }
  const specialDashb = dashbList[itemType];
  if (specialDashb) return specialDashb;

  const isResultDocument = (uiStore.dashBoardItem && uiStore.dashBoardItem.expressionType === "ResultDocument");
  return isResultDocument ? dashbResultDocument : dashbExpr;
});

const getPatientSummary = async () => {
  await folderPatientApi.getSummaryByPatient({ patientId: getSingleElement(route.params.patientId), summaryType: undefined}).then((response: PatientSummaryResponse[]) => {
    currentEntryStore.setPatientSummaryResponse(response);
  })
}

const changeShowRightBar = (show: boolean) => {
  showRightBar.value = show;
};

const getData = async() => {
  uiStore.clearDashBoard();

  currentEntryStore.setReloadTreatmentData(true);

  await currentEntryStore.loadPatientFull(route.params.patientId as string)
}

const openPatientModal = () => {
  currentEntryStore.setCurrentAsModalPatient();
  currentEntryStore.openPatientModal('notes');
}

async function getHealthProDelegate() {
    if (appUserStore.healthProDelegate == null) {
      if (currInstituteUuid.value && currentPerson.value) {
          await instituteApi.getHealthProDelegatePermissionByUser({instituteId: currInstituteUuid.value}).then((result: PersonLightResponse[]) => {
              appUserStore.healthProDelegate = result;

              if (currentPerson.value) {
                appUserStore.healthProDelegate.unshift({
                  id: currentPerson.value.id,
                  firstname: currentPerson.value.firstName,
                  lastname: currentPerson.value.lastName + t('patient.delegate.me')
                })
              }

          }).catch((error: ApiError) => {
              toastError(toast, {
                  summary: t('common.toast.error'),
                  detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
              });
          });
    }
  }
}

async function checkPermission() {
  const hasAccess = await permissionsStore.checkPermission("READ_PATIENT_DATA");

  if (!hasAccess) {
      router.push('/error?error=USER_FORBIDDEN');
  }
}

const setReloadTreatmentCondition = () => {
  currentEntryStore.setReloadTreatmentData(false);
  reloadTreatmentData.value = false;
}

watch(
  () => [
    currInstituteUuid.value,
    currentPerson.value
  ],
  () => {
    getHealthProDelegate();
  }
)

watch(
    () => route.params.patientId,
  () => {
    getData();
    getPatientSummary();
  }
);

watch(
  () => currentEntryStore.reloadTreatmentData,
  () => {
    reloadTreatmentData.value = currentEntryStore.reloadTreatmentData;
  }
)

watch(
  () => currentEntryStore.reloadSummaryData,
  async () => {
    if (currentEntryStore.reloadSummaryData) {
      await getPatientSummary();
      currentEntryStore.setReloadSummaryData(false);
    }
  }
)

onMounted(async () => {
  checkPermission();
  getHealthProDelegate();
  getData();
  getPatientSummary();
});

return (_ctx: any,_cache: any) => {
  const _component_itemModal = _resolveComponent("itemModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(lBarUpperMenu, { onOpenAdmin: openPatientModal }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(lBarCs, {
          onChangeShowRightBar: _cache[0] || (_cache[0] = ($event: any) => (changeShowRightBar($event))),
          onLoadingCommonConcept: _cache[1] || (_cache[1] = ($event: any) => (isLoading.value = $event)),
          onReloadPatientData: _cache[2] || (_cache[2] = ($event: any) => (reloadPatientData.value = true))
        })
      ]),
      (dashb.value)
        ? (_openBlock(), _createBlock(_component_itemModal, {
            key: 0,
            center: true,
            uiId: "mainDashboard"
          }, {
            modal: _withCtx(() => [
              _createElementVNode("div", {
                style: {"margin":"0.8rem 2.2rem 0.8rem 2rem","padding":"1.2rem","height":"97.7vh","cursor":"auto"},
                class: "bg-modal",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(dashb.value)))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (showRightBar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(rBarMonitored, { reloadPatientData: reloadPatientData.value }, null, 8, ["reloadPatientData"]),
                  _createVNode(rBarTtt, {
                    reloadPatientData: reloadTreatmentData.value,
                    onSetReloadPatientData: _cache[4] || (_cache[4] = ($event: any) => (setReloadTreatmentCondition()))
                  }, null, 8, ["reloadPatientData"]),
                  _createVNode(rBarHistory, { reloadPatientData: reloadPatientData.value }, null, 8, ["reloadPatientData"]),
                  _createVNode(rBarEcosystem, { reloadPatientData: reloadPatientData.value }, null, 8, ["reloadPatientData"])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(loadingSpinner, { logo: false }),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('common.loading')), 1)
                ]))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-full es-right-bar" }, null, -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})